import React, { useState } from "react";
import { toast } from "react-toastify";
import loginImage from "../images/image-5.png";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useMyContext } from "../context/MyContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { isLoading, setIsLoading } = useMyContext();
  const navigate = useNavigate();
  const Maily = sessionStorage.getItem("resetEmail");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Regular expression to check if the password meets the required criteria
    const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    // Check if the password meets the criteria
    if (!passwordPattern.test(password)) {
      toast.error(
        "Password must contain at least 8 characters including one uppercase letter, one lowercase letter, and one number."
      );
      setIsLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      // Passwords don't match, show error toast
      toast.error("Passwords do not match");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/forgot/${Maily}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Password: password,
            ConfirmPassword: confirmPassword,
          }),
        }
      );

      const responseData = await response.json();

      if (response.ok && responseData.Access && responseData.Updated) {
        // Password reset successful
        toast.success("Password reset successful");
        navigate("/login");
        // Handle redirect or any other action upon successful password reset
      } else {
        // Handle password reset failure
        toast.error(responseData.Error);
      }
    } catch (error) {
      // Handle error
      toast.error("An error occurred while resetting the password");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex py-4 my-3 w-[95%] lg:w-[85%] mx-auto flex-col lg:flex-row min-h-screen lg:px-8 px-3 justify-between mt-24 lg:mt-0 md:mt-0">
      {/* Left side with image */}
      <div className="lg:w-1/ hidden md:hidden lg:block">
        <img
          src={loginImage}
          alt="Login"
          className="object-cover w-full h-screen "
        />
      </div>

      <div className="lg:w-1/2 flex items-center justify-center mt-8 border border-red-600">
        <div className="lg:max-w-md w-full">
          <h2 className="text-[32px] lg:text-[38px] mb-5 font-extrabold text-black uppercase">
            Forgot Password?
          </h2>

          <form className="mt-4 grid gap-5" onSubmit={handleSubmit}>
            <div className="relative z-0 w-full">
              <label
                htmlFor="password"
                className="block text-base font-semibold text-black"
              >
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="********"
                value={password}
                onChange={handlePasswordChange}
                className="pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300"
              />
              <button
                type="button"
                className="absolute top-[50px] right-2 transform -translate-y-1/2 cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <FaEye size={22} color="#404040" />
                ) : (
                  <FaEyeSlash size={22} color="#404040" />
                )}
              </button>
            </div>

            <div className="relative z-0 w-full mt-4">
              <label
                htmlFor="confirmPassword"
                className="block text-base font-semibold text-black"
              >
                Confirm Password
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                placeholder="********"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                className={`pt-4 px-2 block w-full placeholder:text-sm placeholder:font-light mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-[#405AC6] border-gray-200 transition-colors duration-300 ${
                  password !== confirmPassword ? "border-red-500" : ""
                }`}
              />
              <button
                type="button"
                className="absolute top-[50px] right-2 transform -translate-y-1/2 cursor-pointer"
                onClick={toggleConfirmPasswordVisibility}
              >
                {showConfirmPassword ? (
                  <FaEye size={22} color="#404040" />
                ) : (
                  <FaEyeSlash size={22} color="#404040" />
                )}
              </button>
            </div>

            <button
              type="submit"
              className="w-full mt-6 py-3 bg-[#405AC6] border-none rounded-xl font-medium text-white text-base hover:bg-blue-800 transition-colors duration-300"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
